import VueDataTable from "./VueDataTable";

let vueDataTableId = 0;

export default {
    install(Vue) {
        Vue.prototype.$vueDataTableId = vueDataTableId;
        Vue.component("VueDataTable", VueDataTable);
    }
};

